var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loader"},[_c('loading-bar',{attrs:{"id":"loading-bar-id","custom-class":"innerloader","on-error-done":_vm.errorDone,"on-progress-done":_vm.progressDone,"progress":_vm.progress,"direction":_vm.direction,"error":_vm.error}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d64ecf4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/front/components/LoadingBar.vue
// module id = V95w
// module chunks = 1